import dayjs from "@workspace/domain/src/utils/dayjs";
import * as z from "zod";

const UserType = ["EMPLOYEE", "OWNER"] as const;

const AuditLogSchema = z.object({
  id: z.string(),
  userId: z.string(),
  userType: z.enum(UserType),
  userName: z.string().nullable(),
  model: z.enum([
    "TRIP",
    "CLIENT",
    "RESERVATION",
    "AGENCY",
    "EMPLOYEE",
    "ROLE",
    "PAYMENT",
    "DISCOUNT_CODE",
    "WITHDRAWAL",
  ]),
  action: z.enum(["CREATE", "UPDATE", "DELETE"]),
  resourceId: z.string().nullable(),
  resourceName: z.string().nullable(),
  createdAt: z.date(),
});

const GetAllSchema = z
  .object({
    page: z.number().min(0).default(0),
    limit: z.number().min(1).max(1000).default(20),
  })
  .extend(
    z
      .object({
        dateMin: z.union([
          z.iso.datetime().transform((date) => dayjs(date).toDate()),
          z.date(),
        ]),
        dateMax: z.union([
          z.iso.datetime().transform((date) => dayjs(date).toDate()),
          z.date(),
        ]),
      })
      .partial().shape,
  );

export const AdminAuditLog = {
  UserType,
  AuditLog: AuditLogSchema,
  GetAll: GetAllSchema,
};

export type AdminAuditLog = {
  UserType: (typeof UserType)[number];
  AuditLog: z.infer<typeof AuditLogSchema>;
  GetAll: z.infer<typeof GetAllSchema>;
};
